import AppsPage from "@agenta/oss/src/pages/apps"

export default AppsPage
